const validator = (value) => !!value;
const arrayValidator = (value) => !!value.length;
const numberValidator = (value) => {
  if (value === null || value === undefined || value === "") {
    return false;
  }
  return !isNaN(parseFloat(value)) && isFinite(value);
};
const dateValidator = (value) => !!Date.parse(value);
const weekDayValidator = (value) => {
  let date = new Date(value);
  return date.getDay() > 0 && date.getDay() < 6;
};
const hyperlinkValidator = (value) => !!(value?.href && value?.text);

export const validators = {
  required: validator,
  date: dateValidator,
  time: dateValidator,
  dateWeekDaysOnly: weekDayValidator,
  datetime: dateValidator,
  number: numberValidator,
  person: arrayValidator,
  hyperlink: hyperlinkValidator,
};
